import React, { Suspense, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, Redirect, useLocation , Route} from 'react-router-dom';
import axios from 'axios';

import AuthWrapper from '../Base/AuthWrapper';
import AutoScroll from '../Base/AutoScroll';
import Navigation from '../Base/Navigation';
import routes from '../../routes';
import types from '../../redux/types';
import { checkPermissions } from '../../services/helpers';
import { setupAxiosInterceptors } from '../../services/api';

import { Router } from 'react-router-dom/cjs/react-router-dom.min';
import Users from '../Pages/Users';


const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [sidebar, setSidebar] = useState(false);
  const token = useSelector(state => state.auth.token);
  console.log('localStoragelocalStorage',localStorage.getItem("firoz_token"))
  console.log('token',token)

  const adminPermissions = useSelector(state => state.auth.admin?.permissions) || [];
  const adminPermissionsNames = adminPermissions?.map(perm => perm?.name);
  const [isLogin, setLogin] = useState(false);

  const isMarketShow = checkPermissions(
    [
      'manage assets pairs',
      'add tokens',
      'set limits',
      'set fees',
      'manage currencies',
      'manage market maker',
    ],
    adminPermissionsNames,
  );

  const isSuperAdmin =
    adminPermissionsNames.includes('view orders') &&
    adminPermissionsNames.includes('manage assets pairs') &&
    adminPermissionsNames.includes('add tokens') &&
    adminPermissionsNames.includes('set limits') &&
    adminPermissionsNames.includes('set fees') &&
    adminPermissionsNames.includes('manage currencies') &&
    adminPermissionsNames.includes('view profits') &&
    adminPermissionsNames.includes('manage wallets') &&
    adminPermissionsNames.includes('view referrals') &&
    adminPermissionsNames.includes('manage bank accounts') &&
    adminPermissionsNames.includes('manage admins') &&
    adminPermissionsNames.includes('manage users') &&
    adminPermissionsNames.includes('manage crypto bank transfers') &&
    adminPermissionsNames.includes('manage fiat bank transfers') &&
    adminPermissionsNames.includes('manage market maker') &&
    adminPermissionsNames.includes('manage blog') &&
    adminPermissionsNames.includes('manage general');

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      setLogin(true);
    } else {
      setLogin(false);
    }
  }, [token]);
  useEffect(() => {
    setupAxiosInterceptors(dispatch);
  }, [dispatch]);
  useEffect(() => {
    if (isLogin) {
      dispatch({ type: types.GET_ADMIN_START });
    }
  }, [isLogin]);
  // console.log(isLogin);
  const toggleSidebar = () => {
    setSidebar(!sidebar);
  };

  return (
    <>
      <AutoScroll />
      <div className="admin-wrapper">
        <div className={sidebar ? 'admin-box admin-box--close-bar' : 'admin-box'}>
          {token && <Navigation onToggle={toggleSidebar} value={sidebar} />}
          <div
            className={
              location.pathname === routes.Auth.Login.path
                ? 'dash-main dash-main--admin dash-main--cred-type'
                : 'dash-main dash-main--admin'
            }
          >
            <Suspense fallback={null}>
              <Switch>
                <AuthWrapper
                  auth={token && adminPermissionsNames.includes('manage users')}
                  path={routes.Reset2FA.path}
                  component={routes.Reset2FA.component}
                  redirect={routes.Root.path}
                />
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage users')}
                  path={routes.Root.path}
                  component={routes.Users.component}
                  redirect={routes.Vacancies.path}
                />
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage users')}
                  path={routes.ChatAdminUsers.path}
                  component={routes.ChatAdminUsers.component}
                  redirect={routes.Vacancies.path}
                />
                <AuthWrapper
                  auth={token && isSuperAdmin}
                  path={routes.HistoryReplenishment.path}
                  component={routes.HistoryReplenishment.component}
                />
                {/* Auth */}
                <AuthWrapper
                  auth={!token}
                  path={routes.Auth.Login.path}
                  component={routes.Auth.Login.component}
                />
                {/* Privat routes  */}
                {/* Administration */}
                <AuthWrapper
                  auth={token && adminPermissionsNames.includes('manage admins')}
                  path={routes.Administration.path}
                  component={routes.Administration.component}
                />
                {/* Vacancies */}
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage general')}
                  path={routes.Vacancies.path}
                  component={routes.Vacancies.component}
                />
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage general')}
                  path={routes.Vacancies.NewVacancies.path}
                  component={routes.Vacancies.NewVacancies.component}
                />
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage general')}
                  path={`${routes.Vacancies.EditVacancies.path}:vacancyId`}
                  component={routes.Vacancies.EditVacancies.component}
                />
                {/* Posts */}
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage blog')}
                  path={routes.Posts.path}
                  component={routes.Posts.component}
                />
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage blog')}
                  path={routes.Posts.NewPost.path}
                  component={routes.Posts.NewPost.component}
                />
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage blog')}
                  path={`${routes.Posts.NewPostContent.path}:postId`}
                  component={routes.Posts.NewPostContent.component}
                />
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage blog')}
                  path={`${routes.Posts.EditPost.path}:postId/:lang`}
                  component={routes.Posts.EditPost.component}
                />

                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage blog')}
                  path={routes.Posts.Categories.path}
                  component={routes.Posts.Categories.component}
                />
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage blog')}
                  path={routes.Posts.Categories.NewCategory.path}
                  component={routes.Posts.Categories.NewCategory.component}
                />
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage blog')}
                  path={`${routes.Posts.Categories.EditCategory.path}:categoryId`}
                  component={routes.Posts.Categories.EditCategory.component}
                />
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage blog')}
                  path={`${routes.Posts.Categories.NewCategoryContent.path}:categoryId`}
                  component={routes.Posts.Categories.NewCategoryContent.component}
                />
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage blog')}
                  path={`${routes.Posts.Categories.EditCategoryContent.path}:categoryId/:lang`}
                  component={routes.Posts.Categories.EditCategoryContent.component}
                />
                {/* Vote */}
                <AuthWrapper
                  exact
                  auth={token}
                  path={routes.Vote.path}
                  component={routes.Vote.component}
                />
                <AuthWrapper
                  exact
                  auth={token}
                  path={routes.Vote.NewVoteProject.path}
                  component={routes.Vote.NewVoteProject.component}
                />
                <AuthWrapper
                  exact
                  auth={token}
                  path={`${routes.Vote.NewVoteProjectContent.path}:voteId`}
                  component={routes.Vote.NewVoteProjectContent.component}
                />
                <AuthWrapper
                  exact
                  auth={token}
                  path={`${routes.Vote.EditVoteProjectContent.path}:voteId/:lang`}
                  component={routes.Vote.EditVoteProjectContent.component}
                />
                <AuthWrapper
                  exact
                  auth={token}
                  path={`${routes.Vote.EditVoteProject.path}:voteId`}
                  component={routes.Vote.EditVoteProject.component}
                />
                <AuthWrapper
                  exact
                  auth={token}
                  path={routes.Vote.VoteProjectBalance.path}
                  component={routes.Vote.VoteProjectBalance.component}
                />

                {/* FutureVote */}
                <AuthWrapper
                  exact
                  auth={token}
                  path={routes.FutureVote.path}
                  component={routes.FutureVote.component}
                />
                <AuthWrapper
                  exact
                  auth={token}
                  path={routes.FutureVote.NewFutureVoteProject.path}
                  component={routes.FutureVote.NewFutureVoteProject.component}
                />
                <AuthWrapper
                  exact
                  auth={token}
                  path={`${routes.FutureVote.EditFutureVoteProject.path}:voteId`}
                  component={routes.FutureVote.EditFutureVoteProject.component}
                />
                <AuthWrapper
                  exact
                  auth={token}
                  path={`${routes.FutureVote.EditFutureVoteProjectContent.path}:voteId/:lang`}
                  component={
                    routes.FutureVote.EditFutureVoteProjectContent.component
                  }
                />
                <AuthWrapper
                  exact
                  auth={token}
                  path={`${routes.FutureVote.NewFutureVoteProjectContent.path}:voteId`}
                  component={routes.FutureVote.NewFutureVoteProjectContent.component}
                />

                {/* VoteIEO */}
                <AuthWrapper
                  exact
                  auth={token}
                  path={routes.IEOListing.path}
                  component={routes.IEOListing.component}
                />
                <AuthWrapper
                  exact
                  auth={token}
                  path={routes.IEOListing.NewVoteIEOProject.path}
                  component={routes.IEOListing.NewVoteIEOProject.component}
                />
                <AuthWrapper
                  exact
                  auth={token}
                  path={routes.IEOListing.NewProject.path}
                  component={routes.IEOListing.NewProject.component}
                />
                 <AuthWrapper
                  exact
                  auth={token}
                  path={`${routes.IEOListing.Project.path}:projectId`}
                  component={routes.IEOListing.Project.component}
                />
                <AuthWrapper
                  exact
                  auth={token}
                  path={`${routes.IEOListing.EditVoteIEOProject.path}:voteId`}
                  component={routes.IEOListing.EditVoteIEOProject.component}
                />
                <AuthWrapper
                  exact
                  auth={token}
                  path={`${routes.IEOListing.NewVoteIEOProjectContent.path}:voteId`}
                  component={routes.IEOListing.NewVoteIEOProjectContent.component}
                />
                <AuthWrapper
                  exact
                  auth={token}
                  path={`${routes.IEOListing.EditVoteIEOProjectContent.path}:voteId/:lang`}
                  component={routes.IEOListing.EditVoteIEOProjectContent.component}
                />

                {/* Cashbacks */}
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('set fees')}
                  path={routes.Cashbacks.CashbackList.path}
                  component={routes.Cashbacks.CashbackList.component}
                />
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('set fees')}
                  path={routes.Cashbacks.Statistics.path}
                  component={routes.Cashbacks.Statistics.component}
                />
                {/* Trades */}
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('set fees')}
                  path={routes.Trades.path}
                  component={routes.Trades.component}
                />
                {/* TraderInfo */}
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage general')}
                  path={routes.TraderInfo.path}
                  component={routes.TraderInfo.component}
                />
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage general')}
                  path={`${routes.TraderInfo.EditTraderInfo.path}:traderInfoId`}
                  component={routes.TraderInfo.EditTraderInfo.component}
                />
                {/* FiatTransfer */}
                <AuthWrapper
                  auth={
                    token &&
                    adminPermissionsNames.includes('manage fiat bank transfers')
                  }
                  path={routes.FiatTransfer.Pending.path}
                  component={routes.FiatTransfer.Pending.component}
                />
                <AuthWrapper
                  auth={
                    token &&
                    adminPermissionsNames.includes('manage fiat bank transfers')
                  }
                  path={routes.FiatTransfer.Deposit.path}
                  component={routes.FiatTransfer.Deposit.component}
                />
                <AuthWrapper
                  auth={
                    token &&
                    adminPermissionsNames.includes('manage fiat bank transfers')
                  }
                  path={routes.FiatTransfer.Withdrawals.path}
                  component={routes.FiatTransfer.Withdrawals.component}
                />
                {/* CryptoTransfer */}
                <AuthWrapper
                  auth={
                    token &&
                    adminPermissionsNames.includes('manage crypto bank transfers')
                  }
                  path={routes.CryptoTransfer.Pending.path}
                  component={routes.CryptoTransfer.Pending.component}
                />
                <AuthWrapper
                  auth={
                    token &&
                    adminPermissionsNames.includes('manage crypto bank transfers')
                  }
                  path={routes.CryptoTransfer.Withdrawals.path}
                  component={routes.CryptoTransfer.Withdrawals.component}
                />
                <AuthWrapper
                  auth={
                    token &&
                    adminPermissionsNames.includes('manage crypto bank transfers')
                  }
                  path={routes.CryptoTransfer.Deposit.path}
                  component={routes.CryptoTransfer.Deposit.component}
                />
                {/* Market */}
                <AuthWrapper
                  exact
                  auth={
                    token &&
                    isMarketShow &&
                    adminPermissionsNames.includes('set fees')
                  }
                  path={routes.Market.FeesAndLimits.path}
                  component={routes.Market.FeesAndLimits.component}
                />
                <AuthWrapper
                  exact
                  auth={
                    token &&
                    isMarketShow &&
                    adminPermissionsNames.includes('set fees')
                  }
                  path={routes.Market.TradeVolumeSettings.path}
                  component={routes.Market.TradeVolumeSettings.component}
                />
                <AuthWrapper
                  auth={
                    token &&
                    isMarketShow &&
                    adminPermissionsNames.includes('manage currencies')
                  }
                  path={routes.Market.Currencies.path}
                  component={routes.Market.Currencies.component}
                />
                <AuthWrapper
                  auth={
                    token &&
                    isMarketShow &&
                    adminPermissionsNames.includes('set fees')
                  }
                  path={routes.Market.Fees.path}
                  component={routes.Market.Fees.component}
                />
                <AuthWrapper
                  auth={
                    token &&
                    isMarketShow &&
                    adminPermissionsNames.includes('set limits')
                  }
                  path={routes.Market.Limitations.path}
                  component={routes.Market.Limitations.component}
                />
                <AuthWrapper
                  auth={
                    token &&
                    isMarketShow &&
                    adminPermissionsNames.includes('manage market maker')
                  }
                  path={routes.Market.Robot.path}
                  component={routes.Market.Robot.component}
                />
                <AuthWrapper
                  auth={
                    token &&
                    isMarketShow &&
                    adminPermissionsNames.includes('add tokens')
                  }
                  path={routes.Market.Tokens.path}
                  component={routes.Market.Tokens.component}
                />
                <AuthWrapper
                  auth={
                    token &&
                    isMarketShow &&
                    adminPermissionsNames.includes('manage assets pairs')
                  }
                  path={routes.Market.TradingPairs.path}
                  component={routes.Market.TradingPairs.component}
                />
                {/* Orders */}
                <AuthWrapper
                  auth={token && adminPermissionsNames.includes('view orders')}
                  path={routes.Orders.path}
                  component={routes.Orders.component}
                />
                {/* Videos */}
                <AuthWrapper
                  auth={token && adminPermissionsNames.includes('manage general')}
                  path={routes.Videos.path}
                  component={routes.Videos.component}
                />
                <AuthWrapper
                  auth={token && adminPermissionsNames.includes('view referrals')}
                  path={routes.ReferralSystem.path}
                  component={routes.ReferralSystem.component}
                />
                {/* Users */}
                {/* <> */}
                <AuthWrapper
                  exact
                  auth={token && adminPermissionsNames.includes('manage users')}
                  path={routes.Users.path}
                  component={routes.Users.component}
                  redirect={routes.Vacancies.path}
                />
                <AuthWrapper
                  auth={token && adminPermissionsNames.includes('manage users')}
                  path={`${routes.Users.Profile.path}:userId`}
                  component={routes.Users.Profile.component}
                  redirect={routes.Vacancies.path}
                />
                {/* </> */}
                {/* )} */}
                {/* Wallets */}
                <AuthWrapper
                  auth={
                    token &&
                    adminPermissionsNames.includes('manage wallets') &&
                    adminPermissionsNames.includes('view profits')
                  }
                  path={routes.Wallets.Profits.path}
                  component={routes.Wallets.Profits.component}
                />
                <AuthWrapper
                  auth={token && adminPermissionsNames.includes('manage wallets')}
                  path={routes.Wallets.Transactions.path}
                  component={routes.Wallets.Transactions.component}
                />
                <AuthWrapper
                  auth={token && adminPermissionsNames.includes('manage wallets')}
                  path={routes.Wallets.Wallets.path}
                  component={routes.Wallets.Wallets.component}
                />
                <AuthWrapper
                  auth={token && adminPermissionsNames.includes('manage wallets')}
                  path={routes.Wallets.Bnixfee.path}
                  component={routes.Wallets.Bnixfee.component}
                />
                <AuthWrapper
                  auth={token && adminPermissionsNames.includes('manage wallets')}
                  path={routes.Wallets.GasFeeSettings.path}
                  component={routes.Wallets.GasFeeSettings.component}
                />
                {/* Settings */}
                {/* <AuthWrapper
                  auth={token}
                  path={routes.Settings.BankAccounts.path}
                  component={routes.Settings.BankAccounts.component}
                /> */}
                <AuthWrapper
                  auth={token}
                  path={routes.Settings.Security.path}
                  component={routes.Settings.Security.component}
                />{}
                <Redirect to={routes.Root.path} />
                
              </Switch>
              
            </Suspense>
          </div>
        </div>
      </div>
    </>
  );
};

export default App;
